// Read-only viewer for a Deliverable, rendered as a modal. Primary use is
// the archived-item deep-link flow (F3 Alert → "View archived item").
// In-page view is the inline DeliverableDetailExpand rendered under the
// row. This component is a thin modal wrapper around the same
// DetailExpand so the read-only layout has one source of truth.

import Modal from "../../../common/Modal";
import Button from "../../../common/Button";
import DeliverableDetailExpand from "./DeliverableDetailExpand";
import type { Deliverable } from "../../../../types";

interface DeliverableDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: Deliverable | null;
}

export default function DeliverableDetailModal({
  isOpen,
  onClose,
  item,
}: DeliverableDetailModalProps) {
  if (!item) return null;
  const isArchived = !!item.archivedAt;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        isArchived
          ? "Deliverable / obligation (archived)"
          : "Deliverable / obligation"
      }
      maxWidth="sm:max-w-2xl"
    >
      <div className="space-y-4">
        <DeliverableDetailExpand item={item} />

        <div className="flex justify-end gap-3 pt-2">
          {isArchived && (
            <Button
              variant="secondary"
              disabled
              title="Unarchive to edit — coming soon (self-service)"
              aria-label="Unarchive to edit — coming soon (self-service)"
            >
              Unarchive to edit
            </Button>
          )}
          <Button variant="primary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
}
